import { Inject, Injectable, Optional } from '@angular/core';
import {
  AnalyticsContext,
  AnalyticsProvider,
} from './analytics-provider.interface';
import { ANALYTICS_PROVIDERS } from './analytics.tokens';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private enabled: AnalyticsProvider[] = [];
  private initialized = false;

  constructor(
    @Optional()
    @Inject(ANALYTICS_PROVIDERS)
    private readonly providers: AnalyticsProvider[] | null,
  ) {}

  /** Initialise all enabled providers once. */
  init(context: AnalyticsContext): void {
    if (this.initialized) return;
    this.initialized = true;
    this.enabled = (this.providers ?? []).filter((p) => p.isEnabled());
    this.enabled.forEach((p) => this.safe(p.name, () => p.init(context)));
  }

  trackPageView(url: string): void {
    this.enabled.forEach((p) =>
      this.safe(p.name, () => p.trackPageView(url)),
    );
  }

  trackEvent(eventName: string, params: Record<string, any> = {}): void {
    this.enabled.forEach((p) =>
      this.safe(p.name, () => p.trackEvent(eventName, params)),
    );
  }

  /** One provider failing must never break the app or the other providers. */
  private safe(name: string, fn: () => void): void {
    try {
      fn();
    } catch (err) {
      console.warn(`[analytics:${name}]`, err);
    }
  }
}
